// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iOoEN","label":"styles_label__3SIoc"};